import ApiService from '../base/BaseApiService';

// 引受目安ガード制御の一覧取得
export const fetchGuardControlSeihoHikiukeList = async () => {
  try {
    return await ApiService.get('/guard-control-seiho-hikiuke/list');
  } catch (error) {
    console.error('Error fetching guard control list:', error);
    throw error;
  }
};

// 引受目安ガード制御の一括保存
export const saveGuardControlSeihoHikiukeList = async (guardedCompanyIds) => {
  try {
    return await ApiService.put('/guard-control-seiho-hikiuke/bulk', {
      guarded_company_ids: guardedCompanyIds,
    });
  } catch (error) {
    console.error('Error saving guard control list:', error);
    throw error;
  }
};
